<div class="base-table">
  <div>
    <table mat-table [dataSource]="baseTable.dataSource">
      <ng-container *ngFor="let c of baseTable.columns" [matColumnDef]="c.caption">

        <ng-container *ngIf="c.caption !== 'select'">
          <th mat-header-cell *matHeaderCellDef>
            <!-- {{ c.caption | translate }} -->
            {{ c.caption }}
          </th>
          <td mat-cell *matCellDef="let element">
            <!-- {{ element[c.field] | translate }} -->
            {{
            c.field.parseElement
            ? c.field.parseElement(element)
            : element[c.field.key]
            }}
          </td>
        </ng-container>
      </ng-container>

      <ng-container matColumnDef="actions-menu" *ngIf="showActions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let elemento">
          <button mat-icon-button [matMenuTriggerFor]="menu"></button>
          <mat-menu #menu="matMenu">
            <ng-container *ngFor="let action of baseTable.actions">
              <button mat-menu-item *ngIf="action.hide(elemento)" (onClick)="action.action(elemento)">{{
                action.name
                }}</button>
            </ng-container>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions" *ngIf="showActions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let elemento">
          <div class="actions">
            <div *ngFor="let action of baseTable.actions">
              <button mat-stroked-button *ngIf="action.hide(elemento)" (click)="action.action(elemento)">
                {{action.name}}
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <mat-paginator #paginator *ngIf="baseTable.paginateOptions" [length]="baseTable.paginateOptions.totalCount"
    [pageSize]="baseTable.paginateOptions.pageSize" [pageSizeOptions]="
                baseTable.paginateOptions.pageSizeOptions || [10]
            " (page)="onPageChangeEvent($event)" showFirstLastButtons>
  </mat-paginator>
</div>
